import React from "react";
import logoUrl from "@/assets/knowmeno-logo.png";

/**
 * KnowMeno wordmark — renders the official PNG logo.
 * Props preserved for backwards compatibility across the app.
 */
export function KnowMenoLogo({
  height = 40,
  tagline = false,
  invert = false,
  className,
  style,
}: {
  height?: number;
  tagline?: boolean;
  invert?: boolean;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        gap: tagline ? 6 : 0,
        ...style,
      }}
    >
      <img
        src={logoUrl}
        alt="KnowMeno wordmark logo"
        width={1920}
        height={640}
        decoding="async"
        style={{
          height,
          width: "auto",
          aspectRatio: "1920 / 640",
          display: "block",
          borderRadius: invert ? 6 : 0,
        }}
      />
      {tagline && (
        <span
          aria-hidden="true"
          style={{
            fontFamily:
              '"DM Serif Display","Playfair Display",Georgia,serif',
            fontSize: Math.max(10, height * 0.14),
            letterSpacing: "0.3em",
            color: invert ? "#FFFFFF" : "#4B1F4F",
          }}
        >
          KNOWLEDGE · SUPPORT · EMPOWERMENT
        </span>
      )}
    </span>
  );
}

export default KnowMenoLogo;
